// ---------------------------------------------------------------------------
// Busca global no DOM que prefere o elemento VISÍVEL (BUG-331, 06/10/2026).
//
// Com o `KeepAliveOutlet` as telas de onde se saiu seguem no DOM, escondidas
// (`display: none` do `<Activity>`), e vêm ANTES da tela visível na ordem do
// documento. `document.querySelector` devolve o primeiro casamento — o da tela
// escondida: a chuva de moedas voava para o saldo de um cabeçalho invisível
// (retângulo 0×0) e o foco ia para um campo que não está na tela.
//
// Sem nenhum casamento visível (ou num ambiente sem layout, como o jsdom),
// devolve o primeiro, que é o comportamento de antes.
// ---------------------------------------------------------------------------

function isRendered(el: Element): boolean {
  if (typeof el.checkVisibility === "function") return el.checkVisibility();
  return el.getClientRects().length > 0;
}

export function queryVisible<E extends Element = HTMLElement>(
  selector: string,
  root: ParentNode = document,
): E | null {
  const all = root.querySelectorAll<E>(selector);
  for (const el of all) if (isRendered(el)) return el;
  return all[0] ?? null;
}

/** `getElementById` que prefere o visível (id repetido por tela guardada). */
export function getVisibleElementById<E extends HTMLElement = HTMLElement>(
  id: string,
  root: ParentNode = document,
): E | null {
  return queryVisible<E>(`[id="${CSS.escape(id)}"]`, root);
}
